export function computeTypeState(nodes, edges) {
  const typeNodeIds = new Set(nodes.filter((node) => node.props?.kind === "Type").map((node) => node.id));

  const parents = new Map();
  const children = new Map();
  const directTypes = new Map();

  edges.forEach((edge) => {
    if (edge.type === "IS_A" && typeNodeIds.has(edge.from.nodeId) && typeNodeIds.has(edge.to.nodeId)) {
      if (!parents.has(edge.from.nodeId)) parents.set(edge.from.nodeId, new Set());
      parents.get(edge.from.nodeId).add(edge.to.nodeId);
      if (!children.has(edge.to.nodeId)) children.set(edge.to.nodeId, new Set());
      children.get(edge.to.nodeId).add(edge.from.nodeId);
    }
    if (edge.type === "HAS_TYPE") {
      if (!directTypes.has(edge.from.nodeId)) directTypes.set(edge.from.nodeId, new Set());
      directTypes.get(edge.from.nodeId).add(edge.to.nodeId);
    }
  });

  const inferred = new Map();
  nodes.forEach((node) => {
    const seen = new Set();
    const queue = [...(directTypes.get(node.id) || [])];
    while (queue.length) {
      const current = queue.shift();
      if (seen.has(current)) continue;
      seen.add(current);
      (parents.get(current) || new Set()).forEach((parentId) => queue.push(parentId));
    }
    inferred.set(node.id, seen);
  });

  return {
    typeNodeIds,
    parents,
    children,
    directTypes,
    inferred,
  };
}
